import { useEffect, useRef, useState } from 'react';

/**
 * G17: reactions floating up the picture — each one rises from a random spot
 * along the bottom, drifts, fades, and is gone in three seconds. Pure
 * presentation: hand it the emoji to float and it does the rest.
 */
export function Floaters({ queue, size = 28 }: { queue: string[]; size?: number }) {
  const [items, setItems] = useState<{ id: number; e: string; x: number; drift: number }[]>([]);
  const n = useRef(0);
  useEffect(() => {
    if (queue.length === 0) return;
    const now = queue.map((e) => ({ id: n.current++, e, x: 8 + Math.random() * 84, drift: (Math.random() - 0.5) * 40 }));
    setItems((prev) => [...prev, ...now].slice(-60));
    const ids = new Set(now.map((i) => i.id));
    const t = setTimeout(() => setItems((prev) => prev.filter((i) => !ids.has(i.id))), 3200);
    return () => clearTimeout(t);
  }, [queue]);
  return (
    <div aria-hidden style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden' }} data-tool="floaters">
      <style>{`@keyframes rk-float { 0% { transform: translate(0, 0) scale(.6); opacity: 0 } 10% { opacity: 1; transform: translate(0, -6%) scale(1) } 100% { transform: translate(var(--drift), -110%) scale(1.1); opacity: 0 } }
               @media (prefers-reduced-motion: reduce) { .rk-floater { animation-duration: .01s !important } }`}</style>
      {items.map((i) => (
        <span key={i.id} className="rk-floater" style={{ position: 'absolute', left: `${i.x}%`, bottom: 0, fontSize: size, lineHeight: 1, ['--drift' as string]: `${i.drift}px`, animation: 'rk-float 3s ease-out forwards', willChange: 'transform, opacity' }}>{i.e}</span>
      ))}
    </div>
  );
}
